import { Component, OnInit } from '@angular/core';
import { DataService } from '../../services/data.service';
import { AuthService } from 'ng4-social-login';
import { SocialUser } from 'ng4-social-login';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  private user: SocialUser;
  private loggedIn: boolean;

  constructor (
    public dataService: DataService,
    private authService: AuthService
  ) { }

  ngOnInit() {
    // this.dataService.userType = 'Consumer';
    // this.dataService.fakeReport = true;
    // this.dataService.hub = false;
    // this.dataService.subMenuEnterPrice = false;
    this.authService.authState.subscribe((user) => {
      this.user = user;
      this.loggedIn = (user != null);
    });
  } 

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/landing_page/src/app/components/dashboard/dashboard.component.ts